module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\">{{ initials }}</div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/banner/template.html
// module id = ./components/xo-ui-components/src/banner/template.html
// module chunks = 1